module.exports = __webpack_public_path__ + "img/friendly-room-4.112db1f9.jpg";